import { Row, Divider, Space, Card } from 'antd';
import React, { useMemo } from 'react';
import { CounterHelp, CounterSettingGroup } from '../modules/implementations/shared';

export type CounterSettingDetailsProps = {
    names: Array<
        | 'leadCounter'
        | 'applicationCounter'
        | 'reservationCounter'
        | 'appointmentCounter'
        | 'insuranceCounter'
        | 'eventCounter'
        | 'bookingsCounter'
    >;
};

const CounterSettingDetails = ({ names }: CounterSettingDetailsProps) => {
    if (!names.length) {
        return null;
    }

    const uniqueNames = useMemo(() => Array.from(new Set(names)), [names]);

    return (
        <Card>
            <Divider>ID Generators</Divider>
            <Space direction="vertical" style={{ width: '100%' }}>
                <CounterHelp />
                <Row gutter={10}>
                    {uniqueNames.map(name => (
                        <CounterSettingGroup key={name} name={name} readonly />
                    ))}
                </Row>
            </Space>
        </Card>
    );
};

export default CounterSettingDetails;
